// extracted by mini-css-extract-plugin
module.exports = {"Standout":"Standout_Standout__SrKpO"};